export default "__VITE_ASSET__AIK6zXdo__"